export enum AdminRoleEnum {
	SUPER_ADMIN = "1",
}

export enum CitySIntegradaRoleEnum {
	SINTEGRADA_ADMIN = "6",
	SINTEGRADA_PROFESSIONAL = "7",
}

export enum CityEsusRoleEnum {
	ESUS_ADMIN = "2",
	ESUS_MANAGER = "3",
	ESUS_PROFESSIONAL = "4",
}

export enum StateEsusRoleEnum {
	STATE_ADMIN = "5",
}
